
const banner = [
  {
    img: '/imgs/home/banner1.png',
    title: '领先的供应链解决方案服务商',
    description: '快速响应客户需求，打造应需而变的数字化供应链。',
  },
  {
    img: '/imgs/home/banner2.png',
    title: '物流控制塔（EPLD）',
    description: '基于互联网和SaaS技术建立的全网互联互动、共享协同的可视化云平台。',
  },
  {
    img: '/imgs/home/banner3.png',
    title: '多样化的解决方案',
    description: '网络货运平台：车货匹配、无车承运人\n' +
      '综合物流服务：物流、商流、信息流和资金流“四流合一”\n' +
      '供应链金融：数据链接、智慧金融',
  },
  {
    img: '/imgs/home/banner4.png',
    title: '综合服务',
    description: '为您提供一站式解决方案，包括人力资源、产品运营、IT、综合培训、生态赋能等服务。',
  }
];

const product = [
  {
    img: '/imgs/home/product1.png',
    title: '物流控制塔（EPLD）',
    description: '全链全渠道供应链控制塔指挥系统',
    to: '/product/epld'
  },
  {
    img: '/imgs/home/product2.png',
    title: '运输管理系统（TMS)',
    description: '运输全流程透明化，计费对账自动化',
    to: '/product/tms'
  },
  {
    img: '/imgs/home/product3.png',
    title: '仓储管理系统（WMS）',
    description: '仓储管理可视化，计费对账自动化',
    to: '/product/wms'
  },
  {
    img: '/imgs/home/product4.png',
    title: '数据中心',
    description: '数据可视化，智能分析，决策支持',
    to: '/product/dc'
  },
];

const solution = [
  {
    img: '/imgs/home/solution1.png',
    img2: '/imgs/home/solution_bg1.png',
    img3: '/imgs/home/solution_mobile_bg1.png',
    title: '网络货运平台',
    enTitle: 'NETWORK FREIGHT PLATFORM',
    description: ['平台搭建快速交付','资质代申请','解决进项获取难题','降低税负成本'],
    to: '/solution/transport'
  },
  {
    img: '/imgs/home/solution2.png',
    img2: '/imgs/home/solution_bg2.png',
    img3: '/imgs/home/solution_mobile_bg2.png',
    title: '综合物流服务',
    enTitle: 'INTEGRATED LOGISTIC SERVICE',
    description: ['提供智能化、平台化、','数字化、信息化的','多式联运综合物流','解决方案 '],
    to: '/solution/logistics'
  },
  {
    img: '/imgs/home/solution3.png',
    img2: '/imgs/home/solution_bg3.png',
    img3: '/imgs/home/solution_mobile_bg3.png',
    title: '供应链金融',
    enTitle: 'SUPPLY CHAIN FINANCE',
    description: ['云恋供应链金融系统','可为商贸和供应链企业','提供四流合一的','综合解决方案'],
    to: '/solution/finance'
  }
];

const service = [
  {
    img: '/imgs/home/service1.png',
    title: '人力资源',
    items: [
      {
        title: '人力资源战略 >',
        description: '企业组织规划与设计  |  企业人力需求预测  |  企业人才培养策略设计  |  企业绩效管理',
        to: '/service/hr/strategy'
      },
      {
        title: '组织发展 >',
        description: '业务架构设计  |  组织架构设计  |  组织职责梳理  |  职位体系设计',
        to: '/service/hr/grow'
      },
      {
        title: '人力资源体系 >',
        description: '职位系统  |  招聘管理  |  培训体系  |  绩效管理  |  薪酬激励',
        to: '/service/hr/hierarchy'
      }
    ]
  },
  {
    img: '/imgs/home/service2.png',
    title: '产品运营',
    items: [
      {
        title: '平台项目类全流程申报支持 >',
        description: '政策宣导及解读  |  材料准备及整理  |  方案撰写  |  答辩协同  |  审查指导',
        to: '/service/product/support'
      },
      {
        title: '平台部署及运营推广 >',
        description: '网络平台搭建  |  平台建设方案  |  平台推广方案  |  平台运营方案  |  平台商业模式规划',
        to: '/service/product/spread'
      },
      {
        title: '财务及税务筹划服务 >',
        description: '财税筹划方案  |  税收洼地  |  税收优惠申请',
        to: '/service/product/design'
      }
    ]
  },
  {
    img: '/imgs/home/service3.png',
    title: 'IT',
    items: [
      {
        title: 'IT规划 >',
        description: '互联网+转型规划服务  |  升级产业互联网规划服务  |  基础架构咨询服务  |  应用与基础软件管理服务  |  系统支援及终端设备服务',
        to: '/service/it/schema'
      },
      {
        title: 'IT治理 >',
        description: '信息化标准体系建设  |  信息化管理体系建设  |  业务与IT协同机制建设  |  IT组织运作体系建设',
        to: '/service/it/manage'
      },
      {
        title: 'IT系统建设 >',
        description: '项目可研报告  |  建设方案  |  定制化开发与实施  |  知识转移',
        to: '/service/it/build'
      }
    ]
  },
  {
    img: '/imgs/home/service4.png',
    title: '综合培训',
    items: [
      {
        title: '流程变革方法论 >',
        description: '落实变革项目管理方法论  |  流程优化的原则和方法论  |  流程管理长效机制的建立和持续优化',
        to: '/service/train/flow'
      },
      {
        title: '知识转移与培训 >',
        description: '制定知识转移与培训的策略  |  明确知识形态与知识转移培训资料  |  知识转移与企业自主创新培训',
        to: '/service/train/knowledge'
      }
    ]
  },
  {
    img: '/imgs/home/service5.png',
    title: '生态赋能',
    items: [
      {
        title: '生态战略 >',
        description: '产业链、行业竞争格局分析  |  企业战略执行能力分析评估  |  战略愿景、使命设计  |  标杆研究与对标分析  |  职能战略设计',
        to: '/service/ecology/strategy'
      },
      {
        title: '生态构建 >',
        description: '多元化业务组合  |  企业生态圈设计  |  服务创新与转型  |  运营管理体系建设',
        to: '/service/ecology/build'
      },
      {
        title: '生态资源与合作 >',
        description: '链接专家  |  提供生态赋能资讯服务  |  供应链金融服务  |  综合运营服务  |  政策支持和人才需求',
        to: '/service/ecology/cooperate'
      }
    ]
  }
];

export {banner, product, solution, service};



// WEBPACK FOOTER //
// ./src/routes/Home/config.js